import _ from "lodash";
import initialState from "./state";

export default {
    setPerfectScroll(state, ps) {
        state.perfectScroll = _.cloneDeep(ps);
    },
    updatePerfectScroll(state) {
        if (state.perfectScroll) {
            state.perfectScroll.update();
        }
    },
    reset(state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, initialState());
    },
};
